


































import { Component, Vue } from 'vue-property-decorator';
import storage from '../utils/storage';
import Loading from '../components/Loading.vue';
import moment from 'moment';
import echartsColumn from '../components/echarts/EchartsColumn.vue';
import tableModel from '../components/table/tableModel.vue';
@Component({
  components: {
    Loading,
    echartsColumn,
    tableModel,
  },
})
export default class InspectSame extends Vue {
  private user: any;
  private beforeTime: any = moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD');
  private afterTime: any = moment(new Date()).format('YYYY-MM-DD');
  private dateFormat = 'YYYY-MM-DD';
  private moment: any = moment;
  private dataTime: any = [this.beforeTime, this.afterTime];
  private spinning = false;
  private dataJson: any = [];
  private SKUkey: string = '';
  private xData: string[] = [];
  private yData: string[] = [];
  private allNum: number = 1;
  private isEcharts: boolean = false;
  private columns: any = [{
    title: 'Index',
    dataIndex: 'index',
    width: '5%',
    scopedSlots: { customRender: 'index' },
  }, {
    title: 'shipCity',
    dataIndex: 'shipCity',
    width: '30%',
    scopedSlots: { customRender: 'shipCity' },
  }, {
    title: 'shipState',
    dataIndex: 'shipState',
    width: '20%',
    scopedSlots: { customRender: 'shipState' },
  }, {
    title: 'countNum',
    dataIndex: 'countNum',
    width: '20%',
    scopedSlots: { customRender: 'countNum' },
  }];
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      console.log('please login');
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private async getData() {
    const that = this;
    this.isEcharts = false;
    this.spinning = true;
    // 清空数组
    that.xData.splice(0, that.xData.length);
    that.yData.splice(0, that.yData.length);
    that.allNum = 1;
    const url: string = '/api/getInspectSame';
    const dataTime = [moment(this.dataTime[0]).format('YYYY-MM-DD HH:mm:ss'), this.dataTime[1] + ' 23:59:59'];
    const args = {
      time: dataTime,
      Keyword: this.SKUkey,
    };
    const data = await this.axios.post(url, args);
    that.dataJson = data.data.data;
    that.allNum = Number(data.data.countNum);
    that.dataJson.forEach((item: any, index: number) => {
      const indexStr: string = 'index';
      that.dataJson[index][indexStr] = index + 1;
      const shipCity: string = item.shipCity;
      const countNum: string = item.countNum;
      that.xData.push(shipCity);
      that.yData.push(countNum);
    });
    this.spinning = false;
    this.isEcharts = true;
  }
  private onPickerChange(date: any, dateString: string) {
    this.dataTime = dateString;
  }
  private getCurrentStyle(current: any, today: any): any {
    const style: any = {};
    if (current.date() === 1) {
      style.border = '1px solid #1890ff';
      style.borderRadius = '50%';
    }
    return style;
  }
  private emitEmpty() {
    const inputBox: HTMLInputElement = this.$refs.SKUkeyInput as HTMLInputElement;
    inputBox.focus();
    this.SKUkey = '';
  }
}
